import React, { useEffect, useState } from "react";
import Endorsement, { EndorsementContentIFrame, EndorsementContentMedia, EndorsementContentYouTube } from "../../domain/models/endorsement";

type PropsType = {
  endorsements: Endorsement[]
}

export default function IndexPresenter(props: PropsType) {
  const { endorsements } = props

  const renderIntro = () => {
    return (
      <header className="page-header">
        <h2 className="page-title">Endorsements</h2>
      </header>
    )
  }

  const renderEndorsementMedia = (c: EndorsementContentMedia) => {
    if (c?.media?.mime?.startsWith('image')) {
      return (
        <img key={`media-${c.id}`} src={c.media.url} data-testid="image" style={{ width: '100%' }} />
      )
    }
    if (c?.media?.mime?.startsWith('audio')) {
      return (
        <audio key={`media-${c.id}`} preload="none" style={{ width: '100%' }} controls={true}>
          <source type={c.media.mime} src={c.media.url} data-testid="audio" />
          <a href={c.media.url}>
            {c.media.url}
          </a>
        </audio>
      )
    }
    if (c?.media?.mime.startsWith('video')) {
      return (
        <video key={`media-${c.id}`} style={{ width: '100%' }} controls={true}>
          <source type={c.media.mime} src={c.media.url} data-testid="video" />
          <a href={c.media.url}>
            {c.media.url}
          </a>
        </video>
      )
    }
    return <div key={c.id} />
  }

  const renderEndorsementYouTube = (c: EndorsementContentYouTube) => {
    return (
      <div key={`youtube-${c.id}`} style={{ position: 'relative', width: '100%', paddingTop: '56.25%', paddingBottom: 40 }}>
        <iframe
          data-testid="youtube"
          style={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, width: '100%', height: '100%' }}
          src={`https://www.youtube.com/embed/${c.video_id}?feature=oembed`}
          frameBorder="0"
          scrolling="no"
          allowFullScreen={true}></iframe>
      </div>
    )
  }

  const renderEndorsementIFrame = (c: EndorsementContentIFrame) => {
    return (
      <div key={`iframe-${c.id}`} style={{ position: 'relative', width: '100%', paddingTop: '56.25%', paddingBottom: 40 }}>
        <iframe
          data-testid="iframe"
          style={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, width: '100%', height: '100%' }}
          src={c.url}
          frameBorder="0"
          scrolling="no"
          allowFullScreen={true}></iframe>
      </div>
    )
  }

  const renderEndorsement = (e: Endorsement) => {
    return (
      <article key={e.id} className="post type-post status-publish format-standard hentry category-uncategorized">
        <header className="entry-header">
          <h3 className="entry-title">
            {e.title}
          </h3>
          {(e.summary && e.summary.length > 0) && <p>{e.summary}</p>}
        </header>
        <div className="entry-content">
          {e?.content_items?.length > 0 && e.content_items.map((c) => {
            if (c instanceof EndorsementContentMedia) {
              return renderEndorsementMedia(c)
            }
            if (c instanceof EndorsementContentYouTube) {
              return renderEndorsementYouTube(c)
            }
            if (c instanceof EndorsementContentIFrame) {
              return renderEndorsementIFrame(c)
            }
            return <div />
          })}
        </div>
      </article>
    )
  }

  return (
    <div id="page" className="site container">
      <div className="site-content-contain">
        <div id="content" className="site-content">
          <div className="wrap">
            {renderIntro()}
            <div id="primary" className="content-area">
              <main id="main" className="site-main" role="main">
                {endorsements?.length > 0 && endorsements.map((e) => renderEndorsement(e))}
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
